import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { ValidatedSelect, FormGroup } from "../ui/validated-input";
import { Settings } from "lucide-react";
import { getCurrencyOptions, getTimezoneOptions } from "../../lib/currency";

const CompanySystemCard = ({ company, updateField, isEditing, isValidating }) => {
  const { t } = useTranslation();
  const fuseauxHoraires = getTimezoneOptions();
  const devises = getCurrencyOptions();

  return (
    <Card>
      <CardHeader className="pb-5">
        <CardTitle className="flex items-center gap-2.5 text-sm font-semibold" style={{ color: "var(--lm-ink)" }}>
          <div className="p-1.5 rounded-md" style={{ backgroundColor: "rgba(94,106,210,0.10)" }}>
            <Settings className="h-4 w-4" style={{ color: "#5e6ad2" }} />
          </div>
          <span>{t("companyConfig.sections.systemSettings")}</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <FormGroup>
          <div className="space-y-3">
            <Label htmlFor="primary_color" className="text-sm font-semibold text-foreground">
              {t("companyConfig.labels.primaryColor")}
            </Label>
            <div className="flex items-center space-x-4 p-4 bg-primary/5 rounded-xl border border-primary/20">
              <div
                className="w-12 h-12 rounded-lg border-2 border-border"
                style={{ backgroundColor: company.primary_color }}
              />
              <div className="flex-1">
                <Input
                  id="primary_color"
                  type="color"
                  value={company.primary_color}
                  onChange={(e) => updateField("primary_color", e.target.value)}
                  disabled={!isEditing}
                  className="w-24 h-10 border-0 bg-transparent cursor-pointer"
                />
              </div>
              <div className="text-right">
                <p className="text-sm font-medium text-foreground">{company.primary_color}</p>
                <p className="text-xs text-muted-foreground">{t("companyConfig.labels.colorCode")}</p>
              </div>
            </div>
          </div>

          <ValidatedSelect
            value={company.time_zone || "Africa/Tunis"}
            onValueChange={(value) => updateField("time_zone", value)}
            id="time_zone"
            label={t("companyConfig.labels.timezone")}
            options={fuseauxHoraires}
            disabled={!isEditing}
            isValidating={isValidating}
          />

          <ValidatedSelect
            value={company.default_currency || "TND"}
            onValueChange={(value) => updateField("default_currency", value)}
            id="default_currency"
            label={t("companyConfig.labels.currency")}
            options={devises}
            disabled={!isEditing}
            isValidating={isValidating}
          />
        </FormGroup>
      </CardContent>
    </Card>
  );
};

export default CompanySystemCard;
